const TOUR_STORAGE_PREFIX = "aq_isf_tour_v1";

export function getIsfTourStorageKey(staffId) {
  const id = String(staffId || "").trim();
  return id ? `${TOUR_STORAGE_PREFIX}_${id}` : TOUR_STORAGE_PREFIX;
}

export function hasCompletedIsfTour(staffId) {
  try {
    return localStorage.getItem(getIsfTourStorageKey(staffId)) === "1";
  } catch {
    return false;
  }
}

export function markIsfTourCompleted(staffId) {
  try {
    localStorage.setItem(getIsfTourStorageKey(staffId), "1");
  } catch {
    /* ignore quota errors */
  }
}

export function clearIsfTourCompleted(staffId) {
  try {
    localStorage.removeItem(getIsfTourStorageKey(staffId));
  } catch {
    /* ignore */
  }
}
